'use strict';

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _setPrototypeOf = require('babel-runtime/core-js/object/set-prototype-of');

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Snackbar = require('material-ui/Snackbar');

var _Snackbar2 = _interopRequireDefault(_Snackbar);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _redux = require('../../redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var SnackBar = function (_React$Component) {
  _inherits(SnackBar, _React$Component);

  function SnackBar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SnackBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SnackBar.__proto__ || (0, _getPrototypeOf2.default)(SnackBar)).call.apply(_ref, [this].concat(args))), _this), _this.handleNoticeClose = function () {
      var dispatch = _this.props.dispatch;


      dispatch((0, _redux.setSnackbarMessageAction)(''));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SnackBar, [{
    key: 'render',
    value: function render() {
      var snackbarMessage = this.props.snackbarMessage;

      // specific placement for registration messages

      if (snackbarMessage.includes('A user with the given email is already registered')) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_Snackbar2.default, {
            open: Boolean(snackbarMessage),
            message: snackbarMessage,
            key: snackbarMessage,
            anchorOrigin: { vertical: 'top', horizontal: 'center' },
            autoHideDuration: 8000,
            onClose: this.handleNoticeClose
          })
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Snackbar2.default, {
          open: Boolean(snackbarMessage),
          message: snackbarMessage,
          key: snackbarMessage,
          anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
          autoHideDuration: 4000,
          onClose: this.handleNoticeClose
        })
      );
    }
  }]);

  return SnackBar;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    snackbarMessage: state.snackbarMessage
  };
};

SnackBar.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  snackbarMessage: _propTypes2.default.string.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SnackBar);